const hideContextMenu = () => {
    const contextMenu = document.getElementById('context-menu');
    contextMenu!.style.visibility = "hidden";
}

export default hideContextMenu;